export const OCR_ENDPOINT =
  "http://ec2-13-250-133-136.ap-southeast-1.compute.amazonaws.com/api/ocr/scan?sm=auto&p=0";
let BASE_URL_NODEJS = "https://doiquapg.com";
export const URL_API_UPLOAD_GCS = BASE_URL_NODEJS + "/apinode/upload";
